@if (IFrameOptions) {
  <div class="container-fluid">
    <div class="row row-padding-top">
      <div class="col">
        <div class="vh-80">
          <iframe
            [src]="IFrameOptions.src"
            [style]="IFrameOptions.style"
            [title]="IFrameOptions.title"
          ></iframe>
        </div>
      </div>
    </div>
    <div class="row row-padding">
      <div class="col-4"></div>
      <div class="col-4">
        <button class="btn btn-primary h-100" (click)="close()">Close</button>
      </div>
    </div>
  </div>
}
